import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  clearSuggestionDetails,
  selectData,
  selectIsLoading,
  selectSelectedSuggestion,
  selectSuggestionDetails,
  selectDetailsLoading,
  fetchSuggestions,
  selectSuggestionsLoading,
  startDocumentGeneration,
  fetchData,
  resetState,
  selectSuggestionsError,
  selectDocumentGenerationError,
  setData,
  setChatbotId,
  selectUser,
  selectTilesDetails,
  selectRestrictedDataError,
  setOpenAiTokens, // Import nowej akcji
  setLegalAdvice, // Import dla jawnego dispatch
  selectOpenAiTokens,
} from "../../../../mainApp/features/DataSlice/dataSlice";
import {
  ChatbotContainer,
  ChatbotMain,
  ChatbotDetailsPanel,
  ChatbotForm,
  ChatbotInput,
  ChatbotButton,
  ChatbotExpandButton,
  ChatbotDetailsHeader,
  ChatbotError,
  ChatbotMessage,
  ChatbotDetails,
  ChatbotTextarea,
  AppTitle,
  DocumentTypeSelector,
  TabContainer,
  Tab,
  CopyButton,
  LoadingElement,
} from "../styled";
import LoadingPage from "../../TechnicalTabs/LoadingPage";
import ErrorPage from "../../../../mainApp/features/TechnicalTabs/ErrorPage";
import useWindowDimensions from "../../../../mainApp/features/Hooks/useWindowDimensions";
import { auth, db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { handleUnauthorizedAccess } from "../../Utility/handleUnauthorizedAccess";
import { LEGAL_ADVICE_COST, LEGAL_DOCUMENT_COST } from "../../Utility/tokenCosts";
import LegalDisclaimerModal from "./LegalDisclaimerModal";
import { FaInfoCircle } from "react-icons/fa";
import styled from "styled-components";
import { fetchLegalAdvice } from "./apiService";

const TitleContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  justify-content: center;
`;

const InfoIcon = styled.div`
  color: ${({ theme }) => theme.color.spotifyGrey || "#6e7e91"};
  font-size: 20px;
  cursor: pointer;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  line-height: 1;
  
  
  &:hover {
    color: ${({ theme }) => theme.color.spotifyWhite || "#ffffff"};
  }
`;

const Chatbot = () => {
  const [query, setQuery] = useState("");
  const [activeTab, setActiveTab] = useState("porada");
  const [documentType, setDocumentType] = useState("reklamacja");
  const [documentDetails, setDocumentDetails] = useState("");
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
  const [history, setHistory] = useState([]);
  const [chatHistory, setChatHistory] = useState([
    { text: "Zadaj pytanie prawne", isUser: false },
  ]);
  const [copiedText, setCopiedText] = useState("");
  const [documentError, setDocumentError] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const [openAiTokens, setOpenAiTokensState] = useState(0);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [sessionId] = useState(Date.now().toString()); // Unikalny ID sesji

  const validationToastId = 'lawyer-bot-validation-toast';
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const response = useSelector(selectData);
  const isLoading = useSelector(selectIsLoading);
  const user = useSelector(selectUser);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const suggestionsLoading = useSelector(selectSuggestionsLoading);
  const suggestionsError = useSelector(selectSuggestionsError);
  const documentResponse = useSelector(selectSuggestionDetails);
  const detailsLoading = useSelector(selectDetailsLoading);
  const documentGenerationError = useSelector(selectDocumentGenerationError);
  const theme = useTheme();
  const currentTokens = useSelector(selectOpenAiTokens);

  // Funkcja opóźnienia
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    dispatch(setChatbotId("lawyer"));
    dispatch(clearSuggestionDetails());
    dispatch(resetState());
    dispatch(fetchData());
    setHistory([]);
    setChatHistory([{ text: "Zadaj pytanie prawne", isUser: false }]);
    // Pokaż modal tylko jeśli użytkownik jeszcze nie zaakceptował
    const hasAcceptedDisclaimer = localStorage.getItem('lawyerDisclaimerAccepted');
    if (!hasAcceptedDisclaimer) {
      setShowDisclaimerModal(true);
    }
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          dispatch(fetchData());
          const ref = doc(db, "Users", currentUser.uid);
          const snap = await getDoc(ref);
          if (snap.exists()) {
            // Ustaw początkową liczbę tokenów przy ładowaniu
            // JUŻ NIEPOTRZEBNE - PRZENIESIONE DO NAWIGACJI
          } else {
            console.warn("Dokument użytkownika nie istnieje.");
          }
          await delay(600); // Dodatkowe opóźnienie jako zabezpieczenie
        } catch (error) {
          console.error("Błąd pobierania danych użytkownika:", error);
          await delay(600); // Opóźnienie w przypadku błędu
        }
      } else {
        navigate("/login");
      }
      setInitialLoading(false);
    });
    return () => unsubscribe();
  }, [dispatch, navigate]);

  useEffect(() => {
    if (restrictedDataError) {
      navigate("/unauthorized");
    }
  }, [restrictedDataError, navigate]);

  useEffect(() => {
    if (currentTokens !== openAiTokens) {
      setOpenAiTokensState(currentTokens);
    }
  }, [currentTokens]);

  const handleQueryChange = (e) => setQuery(e.target.value);
  const handleDocumentTypeChange = (e) => setDocumentType(e.target.value);
  const handleDocumentDetailsChange = (e) => {
    setDocumentDetails(e.target.value);
    e.target.style.height = "auto";
    e.target.style.height = `${e.target.scrollHeight}px`;
    setDocumentError("");
  };

  const handleAdviceSubmit = async (e) => {
    e.preventDefault();
    if (!query.trim()) {
      dispatch(setData("Proszę zadać pytanie prawne."));
      return;
    }

    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < LEGAL_ADVICE_COST) {
      toast.error("Masz za mało tokenów, aby uzyskać poradę prawną.", toastOptions);
      return;
    }

    setIsFetching(true);
    const userMessage = query.trim();
    const updatedHistory = [...chatHistory, { text: userMessage, isUser: true }];
    setChatHistory(updatedHistory);
    setHistory((prev) => [...prev, { type: "query", content: query }]);
    setQuery("");

    try {
      const response = await fetchLegalAdvice(userMessage, chatHistory);

      if (response && response.remainingTokens !== undefined) {
        dispatch(setOpenAiTokens(response.remainingTokens));
      }

      const finalHistory = [
        ...updatedHistory,
        {
          text: response.content,
          isUser: false,
          isTruncated: response.isTruncated,
        },
      ];
      setChatHistory(finalHistory);
      setHistory((prev) => [...prev, { type: "response", content: response.content }]);
      dispatch(setLegalAdvice(response));

      // Zapisz historię w Firestore jako jeden dokument dla sesji
      if (user) {
        const filteredHistory = finalHistory.filter(
          (msg, index) => !(index === 0 && !msg.isUser)
        );
        if (filteredHistory.length > 0) {
          const firstUserMessage = filteredHistory.find((msg) => msg.isUser)?.text || "Porada prawna";
          const historyData = {
            chatbotId: "lawyer",
            title: firstUserMessage.slice(0, 50),
            content: JSON.stringify(filteredHistory),
            timestamp: new Date().toISOString(),
          };
          
          await setDoc(doc(db, `Users/${user.uid}/chatHistory`, sessionId), historyData);
          dispatch({ type: "FETCH_CHAT_HISTORY" }); // Odśwież historię
        }
      } else {
        console.warn("No user logged in, skipping history save.");
      }
    } catch (err) {
      console.error("Error fetching legal advice:", err);
      setHistory((prev) => [
        ...prev,
        { type: "response", content: err.message || "Wystąpił błąd podczas generowania odpowiedzi." },
      ]);
      setChatHistory((prev) => [
        ...prev,
        { text: err.message || "Wystąpił błąd podczas generowania odpowiedzi.", isUser: false },
      ]);
    } finally {
      setIsFetching(false);
    }
  };

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    if (!documentDetails.trim()) {
      setDocumentError("Proszę podać szczegóły do dokumentu.");
      return;
    }

    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < LEGAL_DOCUMENT_COST) {
      toast.error("Masz za mało tokenów, aby wygenerować dokument.", toastOptions);
      return;
    }

    setDocumentError("");
    dispatch(startDocumentGeneration());
    dispatch({
      type: "GENERATE_LEGAL_DOCUMENT",
      payload: { documentType, details: documentDetails },
    });
  };

  const toggleDetailsPanel = () => setIsDetailsExpanded((prev) => !prev);

  const handleContinue = async () => {
    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < LEGAL_ADVICE_COST) {
      toast.error("Masz za mało tokenów, aby kontynuować rozmowę.", toastOptions);
      return;
    }

    setIsFetching(true);

    try {
      const response = await fetchLegalAdvice("", chatHistory, true);

      if (response && response.remainingTokens !== undefined) {
        dispatch(setOpenAiTokens(response.remainingTokens));
      }

      const finalHistory = [
        ...chatHistory,
        {
          text: response.content,
          isUser: false,
          isTruncated: response.isTruncated,
        },
      ];
      setChatHistory(finalHistory);
      setHistory((prev) => [...prev, { type: "response", content: response.content }]);
      dispatch(setLegalAdvice(response));

      // Zapisz zaktualizowaną historię w Firestore
      if (user) {
        const filteredHistory = finalHistory.filter(
          (msg, index) => !(index === 0 && !msg.isUser)
        );
        if (filteredHistory.length > 0) {
          const firstUserMessage = filteredHistory.find((msg) => msg.isUser)?.text || "Porada prawna";
          const historyData = {
            chatbotId: "lawyer",
            title: firstUserMessage.slice(0, 50),
            content: JSON.stringify(filteredHistory),
            timestamp: new Date().toISOString(),
          };
         
          await setDoc(doc(db, `Users/${user.uid}/chatHistory`, sessionId), historyData);
          dispatch({ type: "FETCH_CHAT_HISTORY" }); // Odśwież historię
        }
      }
    } catch (err) {
      console.error("Error continuing legal advice:", err);
      setHistory((prev) => [
        ...prev,
        { type: "response", content: err.message || "Wystąpił błąd podczas generowania kontynuacji." },
      ]);
      setChatHistory((prev) => [
        ...prev,
        { text: err.message || "Wystąpił błąd podczas generowania kontynuacji.", isUser: false },
      ]);
    } finally {
      setIsFetching(false);
    }
  };

  const handleCopyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      setTimeout(() => setCopiedText(""), 2000);
    } catch (err) {
      console.error("Błąd kopiowania:", err);
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        setCopiedText(text);
        setTimeout(() => setCopiedText(""), 2000);
      } catch (execErr) {
        console.error("Błąd kopiowania (execCommand):", execErr);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  };

  const isDetailsPanelVisible = activeTab !== "porada" || !isMobile;

  if (initialLoading || isLoading === "loading") {
    return <LoadingPage />;
  }

  let returned;

  switch (isLoading) {
    case "success":
      if (!user) {
        returned = <LoadingPage isHighZIndex={true} />;
      } else if (tilesDetails.length > 0 && user) {
        returned = (
          <ChatbotContainer isLawyer={true}>
            <ChatbotMain
              isDetailsExpanded={isDetailsExpanded}
              isDetailsPanelVisible={isDetailsPanelVisible}
            >
              <TitleContainer>
                <AppTitle isLawyer={true}>Asystent Prawny</AppTitle>
                <InfoIcon onClick={() => setShowDisclaimerModal(true)}>
                  <FaInfoCircle />
                </InfoIcon>
              </TitleContainer>

              <TabContainer>
                <Tab
                  active={activeTab === "porada"}
                  onClick={() => setActiveTab("porada")}
                  isLawyer={true}
                >
                  Porada prawna
                </Tab>
                <Tab
                  active={activeTab === "dokument"}
                  onClick={() => setActiveTab("dokument")}
                  isLawyer={true}
                >
                  Generator dokumentów
                </Tab>
              </TabContainer>

              {activeTab === "porada" && (
                <>
                  <ChatbotForm onSubmit={handleAdviceSubmit}>
                    <ChatbotInput
                      type="text"
                      value={query}
                      onChange={handleQueryChange}
                      placeholder="Zadaj pytanie prawne..."
                      isLawyer={true}
                    />
                    <ChatbotButton
                      type="submit"
                      disabled={isFetching}
                      isLawyer={true}
                      tokenCost={LEGAL_ADVICE_COST}
                    >
                      Zapytaj
                    </ChatbotButton>
                  </ChatbotForm>

                  {isFetching && (
                    <LoadingElement>Analizuję zagadnienie prawne...</LoadingElement>
                  )}

                  {suggestionsError && (
                    <ChatbotError>{suggestionsError}</ChatbotError>
                  )}

                  {chatHistory.length > 0 && (
                    <div>
                      {chatHistory.map((msg, index) => {
                        if (index === 0 && !msg.isUser) {
                          // Pomijamy początkową wiadomość systemową
                          return null;
                        }
                        return (
                          <div key={index}>
                            <ChatbotMessage
                              isLawyer={true}
                              style={{
                                backgroundColor: msg.isUser
                                  ? theme.color.lawyerLightGrey
                                  : theme.color.lawyerDarkGrey,
                                marginLeft: msg.isUser ? "0" : "20px",
                                marginRight: msg.isUser ? "20px" : "0",
                              }}
                            >
                              {msg.text}
                              {!msg.isUser && (
                                <>
                                  <br />
                                  <div style={{ textAlign: "center" }}>
                                    <CopyButton
                                      onClick={() => handleCopyText(msg.text)}
                                    >
                                      {copiedText === msg.text
                                        ? "Skopiowano!"
                                        : "Kopiuj"}
                                    </CopyButton>
                                  </div>
                                </>
                              )}
                            </ChatbotMessage>
                            {msg.isTruncated && !msg.isUser && (
                              <div style={{ 
                                color: "#ff4d4d", 
                                fontSize: "14px", 
                                marginTop: "5px",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                              }}>
                                Wykorzystałeś limit jednej odpowiedzi, jeżeli chcesz kontynuacji, kliknij TAK
                                <button
                                  onClick={() => handleContinue()}
                                  disabled={isFetching}
                                  style={{
                                    padding: "5px 10px",
                                    backgroundColor: theme.color.lawyerGold,
                                    border: "none",
                                    borderRadius: "4px",
                                    color: "#000000",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    transition: "background-color 0.2s ease",
                                  }}
                                  onMouseEnter={(e) => e.target.style.backgroundColor = "#d4af37"}
                                  onMouseLeave={(e) => e.target.style.backgroundColor = theme.color.lawyerGold}
                                >
                                  TAK
                                </button>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {chatHistory.length <= 1 &&
                    !isFetching &&
                    !suggestionsError && (
                      <ChatbotMessage isLawyer={true}>
                        Zadaj pytanie prawne, aby uzyskać poradę.
                      </ChatbotMessage>
                    )}
                </>
              )}

              {activeTab === "dokument" && (
                <>
                  <ChatbotForm onSubmit={handleDocumentSubmit} isLawyer={true}>
                    <DocumentTypeSelector
                      value={documentType}
                      onChange={handleDocumentTypeChange}
                      isLawyer={true}
                    >
                      <option value="reklamacja">Reklamacja</option>
                      <option value="skarga">Skarga</option>
                      <option value="odwołanie">Odwołanie</option>
                      <option value="wezwanie do zapłaty">Wezwanie do zapłaty</option>
                      <option value="wniosek o udostępnienie informacji">
                        Wniosek o udostępnienie informacji
                      </option>
                      <option value="pismo procesowe">Pismo procesowe</option>
                      <option value="umowa">Umowa</option>
                    </DocumentTypeSelector>
                    <ChatbotButton
                      type="submit"
                      disabled={detailsLoading}
                      isLawyer={true}
                      tokenCost={LEGAL_DOCUMENT_COST}
                    >
                      Generuj dokument
                    </ChatbotButton>
                  </ChatbotForm>

                  <div style={{ marginTop: "10px" }}>
                    <ChatbotTextarea
                      value={documentDetails}
                      onChange={handleDocumentDetailsChange}
                      placeholder="Opisz szczegóły sytuacji i podaj niezbędne informacje (np. strony, daty, kwoty, czego dotyczy sprawa)..."
                    />
                    {documentError && <ChatbotError>{documentError}</ChatbotError>}
                  </div>
                </>
              )}
            </ChatbotMain>

            {isDetailsPanelVisible && (
              <ChatbotDetailsPanel isDetailsExpanded={isDetailsExpanded}>
                <ChatbotDetailsHeader
                  isDetailsExpanded={isDetailsExpanded}
                  isLawyer={true}
                />
                <ChatbotExpandButton
                  isDetailsExpanded={isDetailsExpanded}
                  onClick={toggleDetailsPanel}
                  isLawyer={true}
                >
                  {isDetailsExpanded ? "Zwiń dokument" : "Rozwiń dokument"}
                </ChatbotExpandButton>

                {detailsLoading ? (
                  <LoadingElement>Przygotowuję dokument prawny...</LoadingElement>
                ) : documentResponse ? (
                  <>
                    <ChatbotDetails>{documentResponse}</ChatbotDetails>
                    <CopyButton onClick={() => handleCopyText(documentResponse)}>
                      {copiedText === documentResponse
                        ? "Skopiowano!"
                        : "Kopiuj dokument"}
                    </CopyButton>
                  </>
                ) : (
                  <ChatbotMessage isLawyer={true}>
                    {activeTab === "dokument" ? (
                      documentGenerationError ? (
                        <ChatbotError isLawyerDetails={true}>
                          {documentGenerationError}
                        </ChatbotError>
                      ) : (
                        "Wypełnij formularz, aby wygenerować dokument prawny."
                      )
                    ) : (
                      "Zadaj pytanie prawne w oknie po lewej stronie."
                    )}
                  </ChatbotMessage>
                )}
              </ChatbotDetailsPanel>
            )}
          </ChatbotContainer>
        );
      } else {
        returned = handleUnauthorizedAccess();
      }
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  const handleAcceptDisclaimer = () => {
    localStorage.setItem('lawyerDisclaimerAccepted', 'true');
    setShowDisclaimerModal(false);
  };

  return (
    <>
      {returned}
      <LegalDisclaimerModal 
        show={showDisclaimerModal} 
        onAccept={handleAcceptDisclaimer} 
      />
    </>
  );
};

export default Chatbot;